var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6768 17.975C12.8438 21.0581 7.17778 20.4748 4.01145 16.6419C0.84512 12.8089 1.51172 7.05954 5.34464 3.97653C9.17757 0.893522 14.8436 1.47679 18.01 5.30972C20.6764 8.6427 20.6764 13.3089 18.01 16.5585L18.0933 16.6419L21.7596 20.3081C22.0929 20.7248 22.0929 21.308 21.6762 21.6413C21.3429 21.9746 20.7597 21.9746 20.3431 21.6413L16.6768 17.975ZM18.0933 10.9758C18.0933 14.892 14.927 18.0584 11.0107 18.0584C7.09446 18.0584 3.92813 14.892 3.92813 10.9758C3.92813 7.05954 7.09446 3.8932 11.0107 3.8932C14.927 3.8932 18.0933 7.05954 18.0933 10.9758Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDf);
export default __webpack_public_path__ + "static/media/search-df.0b754f47011104ab2227e6d019b2974d.svg";
export { ForwardRef as ReactComponent };